import { createSelector } from 'reselect';
import { getState } from './state';

export const getRealtimeSlice = createSelector([getState], slice => {
  return slice.realtime;
});
